import { useRecoilState } from "recoil";
import Body from "./views/Body";
import Header from "./views/header/Header";
import Wrapper from "./views/Wrapper";
import { BrowserRouter as Router } from "react-router-dom";
import { userAtom } from "./components/atom/atoms";
import "./App.css";
import "./styles/tailwind.css";
import { axiosInstance } from './helpers/helper';
import { useEffect } from "react";
import { ErrorBoundary } from "./components/ErrorBoundary/ErrorBoundary";
import NotFoundPage from "./views/pages/notFound/NotFoundPage";
function App() {
  const [user, setUser] = useRecoilState(userAtom);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axiosInstance.get('/users/me');
        if (response.data.user && response.data.user.id !== user?.id) {
          setUser({...response.data.user});
        }
      } catch (error) {
        console.error("failed to get user data:", error);
      }
    };
    if (!localStorage.getItem('accessToken')) {
      return;
    }
    fetchUserData();
  }, [user?.id, setUser]); // 빈 배열로 설정

  return (
        <Router>
          <Wrapper>
            <Header />
            {/* 마지막 그물 — Header 는 밖에 두어 페이지가 깨져도 이동 수단은 남긴다 */}
            <ErrorBoundary
              label="페이지"
              fallback={<NotFoundPage message="페이지를 표시하는 중 문제가 발생했습니다." />}
            >
              <Body />
            </ErrorBoundary>
          </Wrapper>
        </Router>
  );
}

export default App;
